import { render, staticRenderFns } from "./Sidebar_Button.vue?vue&type=template&id=0a89c42e&scoped=true&"
import script from "./Sidebar_Button.vue?vue&type=script&lang=js&"
export * from "./Sidebar_Button.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar_Button.vue?vue&type=style&index=0&id=0a89c42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89c42e",
  null
  
)

export default component.exports